import { IconMoon, IconSun } from "app/components/Icon/Icon";
import LanguageSelect from "app/components/LanguageSelector/LanguageSelect";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import { NavbarHelper } from "../../helpers/NavbarHelper/NavbarHelper";
import "./AsianNavbar.scss";

type Props = {
  state: Record<string, any>;
  data: Record<string, any>;
  location: any;
  darkMode: boolean;
  toggleDarkMode: Function;
  userLanguage: string;
  onLanguageChangeRequest: Function;
};

const AsianNavbar: React.FC<Props> = ({
  state,
  data,
  location,
  darkMode,
  toggleDarkMode,
  onLanguageChangeRequest,
  userLanguage,
}) => {
  const [username, setUsername] = useState("");

  useEffect(() => {
    setUsername(data.session.username);
  }, [data.session.username]);

  return (
    <div className="asian-navbar">
      <span className="account-name">{username}</span>
      {/* nav menu */}
      {state.asianAuthenticatedMenuItems.map((item, index) => (
        <NavLink
          className="nav-bar__nav-item nav-bar__nav-item--link nav-bar__nav-item--link--asian"
          exact
          to={item.path}
          key={index}
          activeClassName="nav-bar__nav-item--active"
          id={item.id}
        >
          <item.icon
            isLightWhenActive
            isActive={location.pathname.includes(item.path)}
          />
          <span>{item.title}</span>
        </NavLink>
      ))}
      <span
        onClick={() => toggleDarkMode()}
        className={"dark-mode__button"}
        title={"Dark Mode"}
      >
        {darkMode ? <IconSun /> : <IconMoon />}
      </span>
      <LanguageSelect
        onLanguageChangeRequest={onLanguageChangeRequest}
        locale={userLanguage}
        small={true}
      />
      <button type="submit" onClick={() => NavbarHelper.logout(data)}>
        <FormattedMessage tagName="span" id="settings-logout" />
      </button>
    </div>
  );
};

export default AsianNavbar;
